export const TAB_SECTION_SCOPES = {
  applicationSettings: 'application-settings',
  proxySettings: 'proxy-settings',
} as const;

export type TabSectionScope =
  (typeof TAB_SECTION_SCOPES)[keyof typeof TAB_SECTION_SCOPES];
